import { render, staticRenderFns } from "./payment-gateway.vue?vue&type=template&id=1f5cfc46&scoped=true"
import script from "./payment-gateway.vue?vue&type=script&lang=js"
export * from "./payment-gateway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5cfc46",
  null
  
)

export default component.exports